import { DataLayer } from '@grandvisionhq/analytics';

const pushPowerSelectionEvent = (event, eventLabel)=>{
    DataLayer.pushEvent({
        event,
        eventAction: 'plp select lens power',
        eventLabel
    });
};

export { pushPowerSelectionEvent };
//# sourceMappingURL=CustomEventMapper.js.map
